// extracted by mini-css-extract-plugin
export default {"input":"RoundedInput_input__S100W"};